var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item-avatar',{attrs:{"size":_vm.size,"left":""}},[_c('img',{attrs:{"src":_vm.avatar}})])
}
var staticRenderFns = []

export { render, staticRenderFns }